import { isAntennaComplete } from "store/readers-tags/readers/readers-sagas";

export const hasAnyRelevantValue = (antenna: any) => {
  if (!antenna) return false;

  const IGNORE_FIELDS = ["modelDescription", "_slotIndex", "status"];

  return Object.entries(antenna).some(([key, value]) => {
    if (IGNORE_FIELDS.includes(key)) return false;
    return value !== undefined && value !== "" && value !== null;
  });
};

export const antennaNumberValidator = (getFieldValue, index, requiredMessage) => async (_, value) => {
  const antenna = getFieldValue(["antennas", index]);

  if (!hasAnyRelevantValue(antenna)) return;
  if (!value) throw new Error(requiredMessage);
};

export const hasActiveAntenna = (antennas = []) => antennas.some((antenna) => isAntennaComplete(antenna) && antenna.status === true);

export const handleOnCheckConfirmUpdateReaderAntenna = (formReader, formAntenna, setShowConfirmDisableReader, handleOnConfirmDrawerReaderAntenna) => {
  const readerStatus = formReader.getFieldValue("status");
  const antennas = formAntenna.getFieldValue("antennas") || [];

  const shouldConfirm = readerStatus === false && hasActiveAntenna(antennas);

  if (shouldConfirm) {
    setShowConfirmDisableReader(true);
    return;
  }

  handleOnConfirmDrawerReaderAntenna();
};
